import './ToDoLoading.css';

function ToDoLoading() {
  return (
    <>
      <span className='loading-container'></span>
      <span className='loading-container'></span>
      <span className='loading-container'></span>
    </>
  );
}

export { ToDoLoading };